import { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { label: "Menu", target: "menu" },
  { label: "Find the Cart", target: "find-us" },
  { label: "Catering", target: "catering" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    scrollToId(target);
  };

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-black/40 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="transition-transform duration-300 hover:scale-105 active:scale-95"
          aria-label="Back to top"
        >
          <Logo size={40} />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((link) => (
            <button
              key={link.target}
              data-testid={`nav-link-${link.target}`}
              onClick={() => go(link.target)}
              className="text-sm font-medium tracking-wide text-zinc-300 hover:text-disco-yellow transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
          <button
            data-testid="nav-book-us-button"
            onClick={() => go("catering")}
            className="rounded-full bg-disco-yellow text-disco-void text-sm font-semibold px-5 py-2 transition-all duration-300 hover:shadow-[0_0_24px_rgba(226,255,0,0.4)] active:scale-95"
          >
            Book Us
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-zinc-200 p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-black/80 backdrop-blur-xl border-t border-white/10 px-5 py-4 flex flex-col gap-4"
        >
          {LINKS.map((link) => (
            <button
              key={link.target}
              data-testid={`nav-mobile-link-${link.target}`}
              onClick={() => go(link.target)}
              className="text-left text-base text-zinc-200 hover:text-disco-yellow transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-book-us-button"
            onClick={() => go("catering")}
            className="rounded-full bg-disco-yellow text-disco-void text-sm font-semibold px-5 py-2.5 w-fit active:scale-95 transition-transform duration-300"
          >
            Book Us
          </button>
        </div>
      )}
    </header>
  );
}
